module.exports = __webpack_public_path__ + "static/media/event19.6c9316f0.jpeg";